import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { ModalsActions } from 'src/app/core/store/modals/actions/modals.actions';
import { MainButtonComponent } from '../../buttons/main-button/main-button.component';
import { BonusesService } from 'src/app/core/services/bonuses/bonuses.service';
import { AccordionBtnInnerContentComponent } from '../../buttons/accordion-btn-inner-content/accordion-btn-inner-content.component';
import { AdventActions } from 'src/app/core/store/advent/actions/advent.actions';
import { GetBonuses } from 'src/app/core/store/bonuses/actions/bonus.actions';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { selectBonuses } from 'src/app/core/store/bonuses/selector/bonuses.selector';
import { NgOptimizedImage } from '@angular/common';
import { HelpersService } from 'src/app/core/services/helpers/helpers.service';

@Component({
  selector: 'app-advent-modal',
  standalone: true,
  imports: [
    TranslocoModule,
    MainButtonComponent,
    AccordionBtnInnerContentComponent,
    MainButtonComponent,
    NgOptimizedImage,
  ],
  templateUrl: './advent-modal.component.html',
  styleUrl: './advent-modal.component.scss',
})
export class AdventModalComponent implements OnInit, OnDestroy {
  @Input() set adventData(value: any) {
    if (value) {
      this.modalData = {
        ...value,
        title: this.helpers.getTextByUserCurrency(value?.title),
        text: this.helpers.getTextByUserCurrency(value?.text),
        rules: this.helpers.getTextByUserCurrency(value.rules),
      };
    }
  }
  bonuses$: Observable<any> = this.store.select(selectBonuses);
  unsubus$: Subject<boolean> = new Subject<boolean>();
  modalData!: { [key: string]: any };
  hasActiveBonus: boolean = false;
  adventBonus: any = {};

  constructor(
    private store: Store,
    private bonus: BonusesService,
    private navigation: NavigationService,
    private helpers: HelpersService
  ) {}
  ngOnInit() {
    this.bonuses$
      .pipe(
        takeUntil(this.unsubus$),
        filter((res) => res?.isLoaded)
      )
      .subscribe((res) => {
        this.hasActiveBonus =
          res?.activeBonus.length > 0 && res?.activeBonus[0]?.ID.toString() !== this.modalData?.bonusId;
        this.adventBonus = res?.data.filter(({ ID }: any) => ID == this.modalData?.bonusId)[0];
      });
  }
  claimBonus() {
    if (this.adventBonus?.Event?.indexOf('deposit') > -1) {
      setTimeout(() => {
        this.closeModal();
        this.navigation.navigateTo('/(aside:cashier/deposit)', {
          bonus: this.adventBonus?.ID,
          slug: this.adventBonus.Group.toLowerCase().includes('crypto') ? 'crypto' : 'all',
        });
      }, 150);
      return;
    }
    this.bonus.subscribeToBonus(this.modalData.bonusId, '').subscribe(() => {
      this.modalData.isClaimed = true;
      this.store.dispatch(AdventActions['[advent]SetHasClaimedAdventBonus']({ data: true }));
      this.store.dispatch(GetBonuses['[GetBonuses]GetBonuses']());
      this.closeModal();
      this.navigation.navigateTo('/(aside:rewards/bonuses)');
    });
  }
  closeModal() {
    this.store.dispatch(ModalsActions['[modals]CloseModalsSuccess']());
  }

  ngOnDestroy() {
    this.unsubus$.next(true);
    this.unsubus$.complete();
  }
}
